
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { has_Permission } from '../../helpers/jwt-token-access/accessToken'
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  Spinner,
  TabPane,
  Table,
} from "reactstrap";
import classnames from "classnames";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { BaseUrl } from "../../helpers/Baseurl";
import { isEmpty } from "lodash";

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const customStyles = {
  overlay: {
      marginTop: '70px'
  }
}



class LocationDetailPage extends Component {
  constructor(props) {
    super(props);
    this.obj = this.props.obj
    this.state = {
      isFits:false,
      activeTab: 1,
      images : [],
      images_name:[],
      photoIndex:0,
      activeDescriptionTab: "specifications",
      destination: {},
      distances:[],
      
    };
    this.toggleTab = this.toggleTab.bind(this);
    this.toggledescription = this.toggledescription.bind(this);
    this.imageShow = this.imageShow.bind(this);
  }

  componentDidMount() {
    const id =this.props.id
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    fetch(`${BaseUrl}/api/locations/location/locations/${id}/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
              document.title = data.location.name+" | Planmans";                        
              this.setState({ destination:data.location, distances:data.distance })   
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  toggledescription(tab) {
    if (this.state.activeDescriptionTab !== tab) {
      this.setState({
        activeDescriptionTab: tab,
      });
    }
  }

  imageShow(img, id) {
    const expandImg = document.getElementById("expandedImg" + id);
    expandImg.src = img;
  }

  onImageClick(images){
    let image = []
    let images_name = []
    for (let i=0; i<images.length; i++){
        image.push(BaseUrl+images[i].image)
        images_name.push(images[i].name)
    }
    this.setState({ isFits: true, photoIndex: 0, images:image, images_name})
  }

  render() {
    const { destination,distances , images, photoIndex, images_name} = this.state;
    let breadcrumbItems = [
      { title: "Locations", link: "/locations" },
      { title: (destination.name? destination.name: "Location")+" Detail", link: "#" },
    ]
    return (
      <React.Fragment>
        <div className={this.obj?"page-content":"mt-4"}>
          <Container fluid>
          {this.obj?
            <Breadcrumbs
              title={""}
              breadcrumbItems={breadcrumbItems}
            />:null}

            {!isEmpty(destination)?  (
              <React.Fragment>
                 {this.state.isFits ? (
                 
                  <Lightbox
                            
                  reactModalStyle = {this.obj?customStyles:""}
                    mainSrc={images[photoIndex]}
                    nextSrc={images[(photoIndex + 1) % images.length]}
                    prevSrc={
                    images[(photoIndex + images.length - 1) % images.length]
                    }
                    enableZoom={true}
                    onCloseRequest={() => this.setState({ isFits: false })}
                    onMovePrevRequest={() =>
                    this.setState({
                        photoIndex: (photoIndex + images.length - 1) % images.length
                    })
                    }
                    onMoveNextRequest={() =>
                    this.setState({
                        photoIndex: (photoIndex + 1) % images.length
                    })
                    }
                    imageCaption={
                          `Image : ${images_name[photoIndex]}`
                        }
                  />
                  ) : null}
                <Row>
                  <Col lg={12}>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col xl="5">
                            <div className="destination-detail">
                              <Row>
                                <Col xs="3" className="scroll-y">
                                  <Nav className="flex-column" pills>
                                  {destination.image.map(
                                          (item, i) => ( 
                                            
                                    <NavItem>
                                      <NavLink
                                        className={classnames({
                                          active: this.state.activeTab === i+1,
                                        })}
                                        onClick={() => {
                                          this.toggleTab(i+1);
                                        }}
                                      >
                                        <img
                                          src={BaseUrl+item.image}
                                          alt={item.name}
                                          onClick={() => {
                                            this.imageShow(BaseUrl+item.image, i+1);
                                          }}
                                          className="img-fluid mx-auto d-block tab-img rounded"
                                        />
                                      </NavLink>
                                    </NavItem>
                                    ))}
                                  </Nav>
                                </Col>
                                <Col xs="9">
                                  <TabContent
                                    activeTab={this.state.activeTab}
                                    className="position-relative"
                                  >
                                    {destination.image.map(
                                      (item, i) => (  
                                        <TabPane tabId={i+1}>
                                          <div className="destination-img" style={{backgroundColor:"gray", height:"350px"}}>
                                            <img
                                              onClick= {() => this.onImageClick(destination.image)}
                                              src={BaseUrl+item.image}
                                              alt=""
                                              id={"expandedImg"+(i+1)}
                                              className="img-fluid mx-auto d-block"
                                              style={{ maxHeight:"350px", position: "absolute", top: "50%", left: "50%" ,transform: `translateX(-50%) translateY(-50%)`}}
                                            
                                            />
                                          </div>
                                        </TabPane>
                                    ))}
                                  </TabContent>
                                </Col>
                              </Row>
                            </div>
                          </Col>

                          <Col xl="7">
                            <div className="mt-4 mt-xl-3">
                              <Link to="#" className="text-primary">
                              {""}
                              </Link>
                              <h5 className="mt-1 mb-3">{destination.name}</h5>

                            
                              <hr className="my-4" />
                              
                              <Row>
                                <Col md="12">
                                  <div>
                                    <h5 className="font-size-14">
                                      <i className="mdi mdi-location"></i>{" "}
                                      Description
                                    </h5>
                                    <p className="mt-3">{destination.description}</p>
                                  </div>
                                </Col>

                              </Row>
                            </div>
                          </Col>
                        </Row>
                        <div className="mt-4">
                          <h5 className="font-size-14 mb-3">
                            Additional Details:{" "}
                          </h5>
                          <div className="destination-desc">
                            <Nav tabs className="nav-tabs-custom">
                              <NavItem>
                                <NavLink
                                  className={classnames({
                                    active:
                                      this.state.activeDescriptionTab ===
                                      "specifications",
                                  })}
                                  onClick={() => {
                                    this.toggledescription("specifications");
                                  }}
                                >
                                  Detail
                                </NavLink>
                              </NavItem>
                              <NavItem>
                                <NavLink
                                  className={classnames({
                                    active:
                                      this.state.activeDescriptionTab ===
                                      "description",
                                  })}
                                  onClick={() => {
                                    this.toggledescription("description");
                                  }}
                                >
                                  Distances
                                </NavLink>
                              </NavItem>
                             
                              
                            </Nav>
                            <TabContent
                              activeTab={this.state.activeDescriptionTab}
                              className="border border-top-0 p-4"
                            >
                              <TabPane tabId="specifications">
                               <div className="table-responsive">
                                  <Table className="table-nowrap mb-0">
                                    <tbody>
                                    <tr key={'area'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Area"}
                                        </th>
                                        <td>{destination.area} km²</td>
                                    </tr>
                                    <tr key={'elevation'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Elevation"}
                                        </th>
                                        <td>{destination.elevation} m</td>
                                    </tr>
                                    <tr key={'weather'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Weather"}
                                        </th>
                                        <td>{destination.weather}</td>
                                    </tr>
                                    <tr key={'climate'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Climate"}
                                        </th>
                                        <td>{destination.climate}</td>
                                    </tr>
                                    <tr key={'country'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Country"}
                                        </th>
                                        <td>{destination.country.name}</td>
                                    </tr>
                                    <tr key={'state'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"State"}
                                        </th>
                                        <td>{destination.state.name}</td>
                                    </tr>
                                    <tr key={'city'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"City"}
                                        </th>
                                        <td>{destination.city.name}</td>
                                    </tr>
                                    <tr key={'district'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"District"}
                                        </th>
                                        <td>{destination.district.name}</td>
                                    </tr>
                                    <tr key={'zip_code'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Pin Code"}
                                        </th>
                                        <td>{destination.zip_code}</td>
                                    </tr>
                                    <tr key={'coordinates'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Coordinates"}
                                        </th>
                                        <td><a href={"https://www.google.com/search?q="+destination.coordinates} target="__blank">{destination.coordinates}</a></td>
                                    </tr>

                                    </tbody>
                                  </Table>
                                </div>
                              </TabPane>
                              <TabPane tabId="description">
                              <div className="table-responsive">
                                    <Table className="table-nowrap mb-0">
                                        <tbody>
                                            <tr key={'PricingHeading'}>
                                                <th
                                                scope="row"
                                                >
                                                {" "}
                                                </th>
                                                <th
                                                scope="row"
                                                >
                                                {"Location"}
                                                </th>
                                                <th
                                                scope="row"
                                                >
                                                {"Distance"}
                                                </th>
                                               
                                            </tr>
                                            {destination.parent?
                                            <tr key={"parent_destination"}>
                                                <td>{"Parent Destination"}</td>
                                                <td>{destination.parent.name}</td> 
                                                <td>{destination.destination_distance?destination.destination_distance+" km":""}</td>                                           
                                            </tr>
                                            :""
                                            }
                                            
                                            <tr key={"bus_station_distance"}>
                                                <td>{"Nearest Bus Station"}</td>
                                                <td>{destination.nearest_bus_station?destination.nearest_bus_station.name:""}</td> 
                                                <td>{destination.bus_station_distance? destination.bus_station_distance+" km":""}</td>                                           
                                            </tr>
                                            <tr key={"railway_distance"}>
                                                <td>{"Nearest Railway Station"}</td>
                                                <td>{destination.nearest_railway_station?destination.nearest_railway_station.name:""}</td> 
                                                <td>{destination.railway_distance? destination.railway_distance+" km":""}</td>                                          
                                            </tr>
                                            <tr key={"airport_distance"}>
                                                <td>{"Nearest Airport"}</td>
                                                <td>{destination.nearest_airport?destination.nearest_airport.name:""}</td> 
                                                <td>{destination.airport_distance? destination.airport_distance+" km":""}</td>                                           
                                            </tr>
                                            {distances.map((dist, index)=> {
                                              return (<tr key={index}>
                                                <td>{`From ${destination.name}`}</td>
                                                <td>{dist.destination.name}</td> 
                                                <td>{dist.distance} km</td>                                           
                                              </tr>)

                                            })}
                                        </tbody>
                                    </Table>
                                  </div>
                              </TabPane>
                             
                            </TabContent>
                          </div>
                        </div>
                        {has_Permission(this.obj?.user, 1, 'edit' )?
                        <Button type="button" className="btn-sm mt-4" onClick={() => this.props.history.push(`/edit-location/${destination.id}`)} color="info"><i className="fas fa-pen"></i></Button>
                        :null}
                        </CardBody>
                    </Card>
                  </Col>
                </Row>
              </React.Fragment>
            )
            :
            <div className="d-flex align-items-center justify-content-center min-vh-100">
      
              <Spinner type="grow" className="me-2" color="secondary" />
              <Spinner type="grow" className="me-2" color="secondary" />
              <Spinner type="grow" className="me-2" color="secondary" />
              <Spinner type="grow" className="me-2" color="secondary" />
      
            </div>}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}


export default LocationDetailPage ;
